import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Steps from '../../Common/Promotion/Steps';
import ReceiptUpload from '../../Common/Promotion/ReceiptUpload';
import LocationMap from '../../Common/LocationMap/LocationMap';
import Questionaire from '../../Common/Promotion/Questionaire';
import QuestionairePostPromotion from '../../Common/Promotion/QuestionairePostPromotion';
import Confirmation from '../../Common/Promotion/Confirmation';
import LegalAgreementCheckboxSet from '../../Common/Promotion/LegalAgreementCheckboxSet';
import Loader from "../../UI/Loader";
import { useTranslation } from 'react-i18next';
import ModalError from '../../UI/Modal/ModalError';
import PromotionPeriodNotification from '../../Common/Promotion/PromotionPeriodNotification';
import ConfirmationPostPromotion from '../../Common/Promotion/ConfirmationPostPromotion';
import IframeGame from '../../Common/Promotion/IframeGame';
import BrandBanner from '../../Common/BrandBanner/BrandBanner';

const PromotionContest = ({ promotionSettings }) => {
    const [currentStep, setCurrentStep] = useState(1);
    const [savedSelectedImage, setSavedSelectedImage] = useState([]);
    const [formSubmitInProgress, setFormSubmitInProgress] = useState(false);
    const [formSubmitError, setFormSubmitError] = useState(false);
    const [errorMessageCode, setErrorMessageCode] = useState();
    const [errorHeadline, setErrorHeadline] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const [userResponse, setUserResponse] = useState();
    const [image, setImage] = useState();
    const iframe_experience_flag = promotionSettings?.promotionSettings?.iframeExperienceFlag;
    const iframe_experience_host_url = promotionSettings?.promotionSettings?.iframeExperienceHostUrl;

    const { register, handleSubmit, formState, resetField, watch, unregister, formData, trigger, setValue, getValues } = useForm({
        mode: 'onChange'
    });
    const { t } = useTranslation();

    const googleMapsEnabled = promotionSettings.promotion_page.google_maps;

    const handleNextStep = () => {
        setCurrentStep(currentStep + 1);
    };

    const backToStart = () => {
        setFormSubmitError(false);
    };

    const onSubmit = async (formData) => {
        if (formSubmitInProgress) return;
        setFormSubmitError(false);
        setFormSubmitInProgress(true);

        if (formData.hasOwnProperty("file_upload") && formData.file_upload === undefined) delete formData["file_upload"];
        if (formData.hasOwnProperty("store_vat_nr") && formData.store_vat_nr === undefined) delete formData["store_vat_nr"];
        if (formData.hasOwnProperty("receipt_number") && formData.receipt_number === undefined) delete formData["receipt_number"];

        const { file_upload, ...restFormData } = formData;
        const formDataForSubmit = { ...restFormData };

        const fetchURL = window.pathPrefix
            ? `${process.env.REACT_APP_BASE_URL}/${window.pathPrefix}/api/joypepsico-app/v1/promotion/${window.promotionID}/participation`
            : `${process.env.REACT_APP_BASE_URL}/api/joypepsico-app/v1/promotion/${window.promotionID}/participation`;

        fetch(fetchURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formDataForSubmit),
        })
            .then(response => {
                if (!response.ok) {
                    if (response.status >= 500) {
                        throw new Error('Server error');
                    } else {
                        return response.json().then(errorData => {
                            throw errorData;
                        });
                    }
                }

                return response.json();
            })
            .then(data => {
                setUserResponse(data);
                setFormSubmitError(false);
                handleNextStep();

                window.dataLayer.push({
                    event: 'participation_submit',
                    user_id: window.drupalSettings?.pepsico_joy_eu_warehouse_reporting.user_id,
                    event_id: 1.6,
                    event_campaign: promotionSettings.promotion_page.promotion_title,
                    message: 'ok',
                    status: 'success'
                });
            })
            .catch(error => {
                setFormSubmitInProgress(false);
                setFormSubmitError(true);

                if (error.message === 'Server error') {
                    setErrorMessageCode("continue_try_again");
                } else {
                    setErrorMessageCode(error.user_continue);
                    setErrorHeadline(error.headline);
                    setErrorMessage(error.message);
                }

                window.dataLayer.push({
                    event: 'participation_submit',
                    user_id: window.drupalSettings?.pepsico_joy_eu_warehouse_reporting.user_id,
                    event_id: 1.6,
                    event_campaign: promotionSettings.promotion_page.promotion_title,
                    message: error.message === 'Server error' ? 'generic_error' : error.errors,
                    status: 'fail'
                });
            })
            .finally(() => {
                setFormSubmitInProgress(false);
            });
    };


    const handlePostPromotionDataUpdate = () => {
        if (!userResponse) return;

        const postPromotionData = getValues();
        console.log('postPromotionData:', postPromotionData);
        const participationID = userResponse.result._id;
        const fetchURL = window.pathPrefix
            ? `${process.env.REACT_APP_BASE_URL}/${window.pathPrefix}/api/joypepsico-app/v1/promotion/${window.promotionID}/participation/${participationID}`
            : `${process.env.REACT_APP_BASE_URL}/api/joypepsico-app/v1/promotion/${window.promotionID}/participation/${participationID}`;

        setFormSubmitInProgress(true);

        fetch(fetchURL, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(postPromotionData),
        })
            .then(response => {
                if (!response.ok) {
                    if (response.status >= 500) {
                        throw new Error('Server error');
                    } else {
                        return response.json().then(errorData => {
                            throw errorData;
                        });
                    }
                }

                return response.json();
            })
            .then(data => {
                setUserResponse(data);
                setFormSubmitError(false);
                handleNextStep();

                window.dataLayer.push({
                    event: 'profile_enrichment_submit',
                    user_id: window.drupalSettings?.pepsico_joy_eu_warehouse_reporting.user_id,
                    event_id: 1.15,
                    event_campaign: promotionSettings.promotion_page.promotion_title,
                    message: 'ok',
                    status: 'success'
                });
            })
            .catch(error => {
                setFormSubmitInProgress(false);
                setFormSubmitError(true);

                if (error.message === 'Server error') {
                    setErrorMessageCode("continue_try_again");
                } else {
                    setErrorMessageCode(error.user_continue);
                    setErrorHeadline(error.headline);
                    setErrorMessage(error.message);
                }

                window.dataLayer.push({
                    event: 'profile_enrichment_submit',
                    user_id: window.drupalSettings?.pepsico_joy_eu_warehouse_reporting.user_id,
                    event_id: 1.15,
                    event_campaign: promotionSettings.promotion_page.promotion_title,
                    message: error.message === 'Server error' ? 'generic_error' : error.errors,
                    status: 'fail'
                });
            })
            .finally(() => {
                setFormSubmitInProgress(false);
            });
    };

    const callGoToHomepage = () => {
        // console.log('callGoToHomepage executed');
        window.location.href = window.promotionHome;
    }

    const callContinue = () => {
        // console.log('callContinue executed');
        handleNextStep();
    }

    useEffect(() => {

        if (!iframe_experience_host_url) return;

        // console.log('iframe_experience_host_url:', iframe_experience_host_url);

        const iframeCall = (evt) => {
            // console.log(evt.origin);
            if (iframe_experience_host_url && evt.origin !== iframe_experience_host_url) {
                console.warn('Unauthorized message origin:', evt.origin);
                return;
            }
            if (evt.data) {
                switch(evt.data.action) {
                    case 'callGoToHomepage':
                        // console.log('callGoToHomepage');
                        callGoToHomepage();
                        break;
                    case 'callContinue':
                        // console.log('callContinue');
                        callContinue();
                        break;
                    default:
                        console.warn('Unrecognized action:', evt.data.action);
                        break;
                }
            }
        };
    
        window.addEventListener('message', iframeCall);
    
        return () => {
            window.removeEventListener('message', iframeCall);
        };
    }, [iframe_experience_host_url, handleNextStep]); 

    return (
        <div className="promo-container">
            {!(currentStep === 2 && iframe_experience_flag) && (
                <>
                    <Steps promotionSettings={promotionSettings} formSubmitError={formSubmitError} />
                    <div className="form-container" style={{ backgroundImage: `url(${promotionSettings.promotion_page.participation_bg_image})`, backgroundSize: 'cover' }}>
                        <form className="webform-submission-promotion-form pweu-webform-submission-promotion-form" onSubmit={handleSubmit(onSubmit)}>
                            {formSubmitError && <ModalError backToStart={backToStart} formSubmitInProgress={formSubmitInProgress} formSubmitError={formSubmitError} errorMessageCode={errorMessageCode} errorMessageHeadline={errorHeadline} errorMessageText={errorMessage} />}
                            <div className="promo-step-section">
                                {!promotionSettings.participationPeriodActive ? (
                                    <PromotionPeriodNotification promotionSettings={promotionSettings} />
                                ) : (
                                    <>
                                        {currentStep === 1 && (
                                            <div className={`step-${currentStep}`}>
                                                <ReceiptUpload
                                                    register={register}
                                                    formState={formState}
                                                    resetField={resetField}
                                                    setValue={setValue}
                                                    setImage={setImage}
                                                    savedSelectedImage={savedSelectedImage}
                                                    setSavedSelectedImage={setSavedSelectedImage}
                                                    promotionSettings={promotionSettings}
                                                />
                                                {googleMapsEnabled && <LocationMap register={register} formState={formState} resetField={resetField} watch={watch} formData={formData} unregister={unregister} trigger={trigger} promotionSettings={promotionSettings} getValues={getValues} setValue={setValue} />
                                                }
                                                <Questionaire
                                                    register={register}
                                                    formState={formState}
                                                    resetField={resetField}
                                                    trigger={trigger}
                                                    setValue={setValue}
                                                    savedSelectedImage={savedSelectedImage}
                                                    setSavedSelectedImage={setSavedSelectedImage}
                                                    promotionSettings={promotionSettings}
                                                />
                                                <LegalAgreementCheckboxSet
                                                    register={register}
                                                    formState={formState}
                                                    promotionSettings={promotionSettings}
                                                    formSubmitInProgress={formSubmitInProgress}
                                                    formSubmitError={formSubmitError}
                                                />
                                                <div className="promo-fields-group">
                                                    <div className="promo-fields promo-action-fields">
                                                        <div className="promo-field info">
                                                            <p>*{t("Required fields")}</p>
                                                        </div>
                                                        <div className="promo-field action">
                                                            <div>
                                                                {formSubmitInProgress ? <Loader /> : (
                                                                    <>
                                                                        {promotionSettings.promotion_type.receipt_submitting_options === "manual" || promotionSettings.promotion_type.receipt_submitting_options === "none" ? (
                                                                            <>
                                                                                <a href={window.promotionHome} className="btn btn-primary-text">{t("Go Back")}</a>
                                                                                <input type="submit" className="btn btn-primary" disabled={!formState.isValid} value={t("Submit")} />
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <a href={window.promotionHome} className="btn btn-primary-text">{t("Go Back")}</a>
                                                                                <input type="submit" className="btn btn-primary" disabled={!formState.isValid || !image} value={t("Submit")} />
                                                                            </>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {((currentStep === 2 && !iframe_experience_flag) || (currentStep === 3 && iframe_experience_flag)) && (
                                            <div className={`step-${currentStep}`}>
                                                <Confirmation promotionSettings={promotionSettings} userResponse={userResponse} />
                                                <QuestionairePostPromotion
                                                    register={register}
                                                    formState={formState}
                                                    userResponse={userResponse}
                                                    formSubmitInProgress={formSubmitInProgress}
                                                    onPostPromotionDataUpdate={handlePostPromotionDataUpdate}
                                                    resetField={resetField}
                                                    trigger={trigger}
                                                    setValue={setValue}
                                                    savedSelectedImage={savedSelectedImage}
                                                    setSavedSelectedImage={setSavedSelectedImage}
                                                    promotionSettings={promotionSettings}
                                                />
                                            </div>
                                        )}
                                        {((currentStep === 3 && !iframe_experience_flag) || (currentStep === 4 && iframe_experience_flag)) && (
                                            <div className={`step-${currentStep}`}>
                                                <ConfirmationPostPromotion />
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </form>
                        

                        {promotionSettings.activeBrand.class === "brand-snacks-canister" && <>
                            {((iframe_experience_flag && currentStep >= 3) || (!iframe_experience_flag && currentStep >= 2)) && <>
                                <BrandBanner promotionSettings={promotionSettings} />
                            </>}
                        </>}
                    </div>
                </>
            )}

            {(currentStep === 2 && iframe_experience_flag) && (
                <div className={`step-${currentStep}`}>
                    <IframeGame userResponse={userResponse} />
                </div>
            )}
        </div>
    );
};

export default PromotionContest;
